import { addDays, compareAsc } from 'date-fns';

import {
  mixpanelDataMaskingFieldList,
  WebinarDayWithSlotFieldOptionType
} from '@nw/shared/config';

import { EMOJI_REGEX_PATTERN } from '../../constants/ValidationRegex';

export const getFilteredOptions = (
  options: Array<WebinarDayWithSlotFieldOptionType>,
  dependentFieldValue: string
) => {
  return options.filter((eachOption) =>
    eachOption.match_keys.includes(dependentFieldValue)
  );
};

export const getPreferredDates = (minDate: string, maxDate: string): Date[] => {
  const preferredDates: Date[] = [];
  let date = eval(minDate);
  const maximumDate = new Date(eval(maxDate));
  while (compareAsc(date, maximumDate) !== 0) {
    preferredDates.push(date);
    date = new Date(addDays(date, 1));
  }
  preferredDates.push(maximumDate);
  return preferredDates;
};

export const removeEmojisFromString = (text: string): string => {
  return text.replace(EMOJI_REGEX_PATTERN, '');
};

export const shouldEnableDataMaskBasedOnField = (field): boolean => {
  if (mixpanelDataMaskingFieldList.includes(field)) {
    return true;
  }
  return false;
};
